import type { Evidence, Flag, RuleMeta, Severity, Signals, SignalModuleId } from '@fraudeai/schema';

/** Результат срабатывания правила. `null` означает «расхождений не найдено». */
export interface RuleHit {
  /** 0..1. По умолчанию 1 — правило полностью уверено в срабатывании. */
  confidence?: number;
  /** Объяснение для пользователя, обычным языком и без жаргона. */
  explanation: string;
  evidence: Evidence[];
  /** Переопределение серьёзности, если она зависит от масштаба находки. */
  severity?: Severity;
  flags?: Flag[];
}

export interface Rule {
  meta: RuleMeta & { requires: SignalModuleId[] };
  evaluate(signals: Partial<Signals>): RuleHit | null;
}

/** Хелпер только ради вывода типов. */
export function defineRule(rule: Rule): Rule {
  return rule;
}
